<template>

  <!-- <div id="hello">
    <router-link :to="{ name: 'Home' }"  v-if="currentRouteName != 'Home'">
      <img src="logo.svg" id="logo" />
    </router-link>
    <span v-else>
      <img src="logo.svg" id="logo" />
    </span>
  </div> -->

  <!-- <div id="content">
    <router-view />
  </div> -->

  <!-- <div id="bottom">
    2023 &copy; GoodTrip.Games

    <div id="social">
      <a href="mailto:hello@goodtrip.games">
        <at-icon :size="30" />
      </a>
      <a href="https://tovgames.itch.io/">
        <img src="itchio.svg" width="28" height="28" />
      </a>
      <a href="https://instagram.com/tov.games">
        <instagram-icon :size="30" />
      </a>
      <a href="https://twitter.com/tov_games">
        <twitter-icon :size="30" />
      </a>
    </div>
  </div> -->

  <div id="full">
    <a href="mailto:hello@goodtrip.games"><img src="Logo-transparent.svg" id="logo" /></a>
  </div>
</template>

<script>
import AtIcon from 'vue-material-design-icons/At.vue';
import InstagramIcon from 'vue-material-design-icons/Instagram.vue';
import FacebookIcon from 'vue-material-design-icons/Facebook.vue';
import TwitterIcon from 'vue-material-design-icons/Twitter.vue';
import SteamIcon from 'vue-material-design-icons/Steam.vue';

export default {
  name: 'App',
  components: {
    AtIcon,
    InstagramIcon,
    FacebookIcon,
    TwitterIcon,
    SteamIcon,
  },
  computed: {
    currentRouteName() {
        return this.$route.name;
    },
  },
}
</script>

<style lang="less">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
}
html {
  background: transparent;
}
body {
  text-align: center;
  margin: 0;
  padding: 0;
  font-family: Helvetica, sans-serif;
  font-size: 17px;
  background-color: #EBE4D4;
  color: #444444;
}
div#full {
  width: 100vw;
  height: 100dvh;
  display: flex;
  justify-content: center; /* Центрирование по горизонтали */
  align-items: center;     /* Центрирование по вертикали */
  img#logo {
    width: 180px;
    height: 180px;
  }
}

h1, h2 {
  font-weight: 300;
  margin-bottom: 20px;
}

h1 {
  font-size: 50px;
}
h2 {
  font-size: 40px;
}
a {
  color: #7DB9B6;
}
p {
  margin-bottom: 20px;
  line-height: 140%;
}

div#hello {
  width: 100%;
  padding: 120px;
  img#logo {
    width: 400px;
    height: 100px;
  }
}

div#content {
  width: 760px;
  margin: auto;
  text-align: left;
}
div#bottom {
  padding-bottom: 120px;
  a {
    color: #4D455D;
  }
  div#social {
    padding-top: 20px;
    a {
      margin: 0 4px;
    }
  }
}

@media only screen and (max-width: 768px) {
  body {
    font-size: 20px;
  }
  div#content {
    width: 100%;
    padding: 0 40px;
  }
}

</style>
